<form [formGroup]="smsForm">
  <div class="form-cards-wrapper">
    <mat-card class="form-card">
      <mat-card-header>
        <div class="form-header">
          <mat-card-title>Business information</mat-card-title>
          <mat-icon *ngIf="formLocked">lock</mat-icon>
        </div>
      </mat-card-header>

      <mat-card-content>
        <!-- Legal business name -->
        <glxy-form-field [required]="true">
          <glxy-label>
            <span>Legal business name</span>
          </glxy-label>
          <input formControlName="businessName" matInput />
          <glxy-hint
            *ngIf="!(smsForm.controls.businessName.hasError('maxlength') && smsForm.controls.businessName.touched)"
          >
            This must be the same name your business uses for tax purposes. For example: Roadside Coffee Inc.
          </glxy-hint>
          <glxy-error
            *ngIf="smsForm.controls.businessName.hasError('maxlength') && smsForm.controls.businessName.touched"
          >
            Business name should be maximum of 64 characters.
          </glxy-error>
        </glxy-form-field>

        <!-- Business category aka Industry -->
        <glxy-form-field [required]="true">
          <glxy-label>
            <span>Business category</span>
          </glxy-label>
          <mat-select formControlName="businessCategory">
            <mat-option *ngFor="let businessCategory of BusinessCategories" [value]="businessCategory">
              {{ businessCategory | businessCategoryToLabel }}
            </mat-option>
          </mat-select>
        </glxy-form-field>

        <!-- Business type -->
        <glxy-form-field [required]="true">
          <glxy-label>
            <span>Business type</span>
          </glxy-label>
          <mat-select formControlName="businessType">
            <mat-option *ngFor="let businessType of BusinessTypes" [value]="businessType">
              {{ businessType }}
            </mat-option>
          </mat-select>
        </glxy-form-field>

        <!-- Country / Region -->
        <glxy-form-field [required]="true">
          <glxy-label>
            <span>Country/region</span>
          </glxy-label>
          <mat-select formControlName="regionOfOperation">
            <mat-option *ngFor="let region of Regions" [value]="region">{{ region | regionToLabel }}</mat-option>
          </mat-select>
        </glxy-form-field>

        <!-- Business registration number -->
        <glxy-form-field [required]="true">
          <glxy-label>
            <span>Business registration number</span>
          </glxy-label>
          <input formControlName="businessRegistrationNumber" matInput />
          <glxy-hint
            *ngIf="
              !(
                smsForm.controls.businessRegistrationNumber.hasError('pattern') &&
                smsForm.controls.businessRegistrationNumber.touched
              )
            "
          >
            For US-based companies, this must be your business EIN number
          </glxy-hint>
          <glxy-error
            *ngIf="
              smsForm.controls.businessRegistrationNumber.hasError('pattern') &&
              smsForm.controls.businessRegistrationNumber.touched
            "
          >
            For US-based companies, this must be your business EIN number
          </glxy-error>
        </glxy-form-field>

        <!-- Address -->
        <glxy-form-field [required]="true">
          <glxy-label>
            <span>Address</span>
          </glxy-label>
          <input formControlName="address" matInput />
        </glxy-form-field>

        <!-- Additional address line -->
        <glxy-form-field>
          <glxy-label>
            <span>Additional address line</span>
          </glxy-label>
          <input formControlName="additionalAddressLine" matInput />
        </glxy-form-field>

        <glxy-form-row>
          <!-- State -->
          <glxy-form-field [required]="true" class="col-xs-12 col-sm-6">
            <glxy-label>
              <span>State</span>
            </glxy-label>
            <input formControlName="state" matInput />
          </glxy-form-field>

          <!-- City -->
          <glxy-form-field [required]="true" class="col-xs-12 col-sm-6">
            <glxy-label>
              <span>City</span>
            </glxy-label>
            <input formControlName="city" matInput />
          </glxy-form-field>
        </glxy-form-row>

        <!-- Zip code -->
        <glxy-form-field [required]="true">
          <glxy-label>
            <span>Zip Code</span>
          </glxy-label>
          <input formControlName="zipCode" matInput />
          <glxy-error *ngIf="smsForm.controls.zipCode.hasError('pattern') && smsForm.controls.zipCode.touched">
            Not a valid zip code
          </glxy-error>
        </glxy-form-field>

        <!-- Website -->
        <glxy-form-field [required]="true">
          <glxy-label>
            <span>Website</span>
          </glxy-label>
          <input formControlName="website" matInput type="url" />
          <glxy-hint>If you don't have a business website, provide an online listing</glxy-hint>
        </glxy-form-field>
      </mat-card-content>
    </mat-card>

    <mat-card class="form-card">
      <mat-card-header>
        <div class="form-header">
          <mat-card-title>Authorized business representative</mat-card-title>
          <mat-icon *ngIf="formLocked">lock</mat-icon>
        </div>
      </mat-card-header>
      <mat-card-content>
        <glxy-form-row>
          <!-- First name -->
          <glxy-form-field [required]="true" class="col-xs-12 col-sm-6">
            <glxy-label>
              <span>First name</span>
            </glxy-label>
            <input formControlName="firstName" matInput />
          </glxy-form-field>

          <!-- Last name -->
          <glxy-form-field [required]="true" class="col-xs-12 col-sm-6">
            <glxy-label>
              <span>Last name</span>
            </glxy-label>
            <input formControlName="lastName" matInput />
          </glxy-form-field>
        </glxy-form-row>

        <!-- Job position -->
        <glxy-form-field [required]="true">
          <glxy-label>
            <span>Job position</span>
          </glxy-label>
          <mat-select formControlName="jobPosition">
            <mat-option *ngFor="let jobPosition of JobPositions" [value]="jobPosition">
              {{ jobPosition }}
            </mat-option>
          </mat-select>
        </glxy-form-field>

        <!-- Business title -->
        <glxy-form-field [required]="true">
          <glxy-label>
            <span>Title</span>
          </glxy-label>
          <input formControlName="businessTitle" matInput />
          <glxy-hint>For example CEO, CTO, Manager</glxy-hint>
        </glxy-form-field>

        <!-- Email -->
        <glxy-form-field [required]="true">
          <glxy-label>
            <span>Email</span>
          </glxy-label>
          <input formControlName="email" matInput type="email" />
          <glxy-hint>Email of Authorized Business Representative</glxy-hint>
          <glxy-error *ngIf="smsForm.controls.email.hasError('email') && smsForm.controls.email.touched">
            Not a valid email
          </glxy-error>
        </glxy-form-field>

        <!-- Phone number -->
        <glxy-form-field [required]="true">
          <glxy-label>
            <span>Phone number</span>
          </glxy-label>
          <input formControlName="phoneNumber" matInput type="tel" />
          <glxy-hint
            *ngIf="!(smsForm.controls.phoneNumber.hasError('pattern') && smsForm.controls.phoneNumber.touched)"
          >
            Best way to contact the authorized business representative. Required format +1-123-456-7890
          </glxy-hint>
          <glxy-error *ngIf="smsForm.controls.phoneNumber.hasError('pattern') && smsForm.controls.phoneNumber.touched">
            Required format +1-123-456-7890
          </glxy-error>
        </glxy-form-field>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="actions">
    <button (click)="submitRegistrationForm()" [disabled]="formLocked" color="primary" mat-flat-button type="submit">
      Submit information
    </button>

    <button (click)="saveChanges()" [disabled]="formLocked" mat-stroked-button type="submit">Save changes</button>
  </div>
</form>
